import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import { downloadSubProjectIncomeRecordAttacthment } from '../../../redux/actions/subProjectIncomeRecord'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { sessionGetItemStr, sessionRemoveItem } from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import { previewFile } from '../../../utils/fileUtil'
import FundManagerAuditIssuesForm from './FundManagerAuditIssuesForm'
import InfoReportsAudit from '../reportsAuditWidgets/InfoReportsAudit'
import { saveFundManagerAudit } from '../../../redux/actions/fundManagerAudit'
import ReportsAuditIAP12Widget from '../reportsAuditWidgets/ReportsAuditIAP12Widget'

export default function FundManagerAuditIssuesWidget(props) {
  // const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [requestBody, setRequestBody] = useState()
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [isSaveDraft, setIsSaveDraft] = useState(false)
  const [isViewMode, setIsViewMode] = useState(false)

  let history = useHistory()

  useEffect(() => {
    let isViewMode = !!sessionGetItemStr('directorAuditViewMode')

    console.log(
      'sessionGetItemStr(directorAuditViewMode) : ',
      sessionGetItemStr('directorAuditViewMode')
    )
    console.log('isViewMode : ', isViewMode)

    if (isViewMode) {
      setIsViewMode(isViewMode)
      sessionRemoveItem('directorAuditViewMode')
    }
  }, [])

  const handleCallService = async () => {
    console.log('handleCallService3 ', requestBody)
    startLoading()
    setIsLoading(true)
    try {
      const response = await saveFundManagerAudit(requestBody, formSchema?.form?.id, isSaveDraft)
      console.log('response==>', response)
      if (response) {
        // setFormSchema(response?.model)
        // console.log('response222==>', response)
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        // setRequestBody()
        setIsShowConfimModal(false)
      } else {
        setIsError()
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data==fff=>1 ', data)

    let _request = {
      id: formSchema.form.id,
      approverType: data.approveOption,
      comment: data.approveComment,
    }
    console.log('request===>2 ', _request)
    setIsSaveDraft(false)
    setRequestBody(_request)
    setIsShowConfimModal(true)
  }

  const handleCancel = () => {
    console.log('handleCancel')
    // sessionRemoveItem('auditInfo')

    // history.push(`${pathname.audit.AuditReportSummary}`)
  }

  const onSubmitDraft = () => {
    var data = {}
    //clear error all input
    for (const key in getValues()) {
      Object.assign(data, { [`${key}`]: getValues(key) })
      clearErrors(key)
    }
    console.log('onSubmitDraft===> : ', data)
    setRequestBody(data)
    setIsSaveDraft(true)
    setIsShowConfimModal(true)
  }

  const handleOnConfirmModal = () => {
    // console.log('dataghfghgfhg  ', requestBody)
    // let request = {
    //   id: formSchema?.form?.id,
    //   approverType: requestBody.approveOption,
    //   comment: requestBody.approveComment,
    // }
    // console.log('requestToCallService===>', request)
    handleCallService()
  }

  const onPreview = async (filePath) => {
    startLoading()
    try {
      var files = filePath?.split('/')
      var file = await downloadSubProjectIncomeRecordAttacthment(filePath)

      previewFile(file, files[files.length - 1])
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <InfoReportsAudit schema={formSchema?.projectInfo} showButton={true} />

        {formSchema?.form && (
          <FundManagerAuditIssuesForm
            schema={formSchema?.form}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            setIsEnableEdit={setIsEnableEdit}
            isViewMode={isViewMode}
          />
        )}

        {formSchema?.form?.isIAp12AttachSchema && (
          <ReportsAuditIAP12Widget
            shaded={false}
            auditId={formSchema.form.id}
            style={{ marginTop: 10 }}
          />
        )}

        {!isViewMode && (
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema?.form?.button?.saveButton && (
                <SaveButton
                  style={{ marginRight: 5 }}
                  // onClick={handleSubmit(onSubmitDraft)}
                  onClick={() => {
                    onSubmitDraft()
                  }}
                  disabled={isLoading}
                >
                  {formSchema?.form?.button?.saveButton}
                </SaveButton>
              )}

              {formSchema?.form?.button?.submitButton && (
                <SaveButton onClick={handleSubmit(onSubmit)} style={{ marginRight: 5 }}>
                  {formSchema?.form?.button?.submitButton}
                </SaveButton>
              )}

              <CancelButton
                style={{ marginTop: 0 }}
                onClick={() => {
                  handleCancel()
                }}
              >
                {'ยกเลิก'}
              </CancelButton>
            </Col>
          </Row>
        )}
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการ${isSaveDraft ? 'บันทึกร่าง' : formSchema.buttonText || 'บันทึก'}`}
        show={isShowConfimModal}
        // detail={`กรุณายืนยันการ${isSaveDraft ? 'บันทึกร่าง' : formSchema.buttonText}`}
        onCancle={() => {
          //setIsSaveDraft(false)
          setIsShowConfimModal(false)
        }}
        onConfirm={handleOnConfirmModal}
      />
    </>
  )
}
